import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { contentCSS } from '@macs-frontend/web-macs/core/utils/tinymce';
import * as iframeResizerModule from 'iframe-resizer';
import { UploadedFile } from '@macs-frontend/features/shared';
import { environment } from '@macs-frontend/env';

@Component({
  selector: 'md-briefing-preview',
  templateUrl: './briefing.component.html',
  styleUrls: ['./briefing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BriefingComponent implements OnInit, OnDestroy {
  // @ts-expect-error
  @Input() content: string;
  @Input() files: UploadedFile[] = [];

  imagesPath = environment.images_path;

  iframe: HTMLIFrameElement;
  styleUrls = contentCSS.concat('/assets/css/iframe.css');
  scriptUrls = ['/assets/js/iframeResizer.contentWindow.min.js'];
  resizerOptions: iframeResizerModule.IFrameOptions = {
    heightCalculationMethod: 'max',
    checkOrigin: false,
    autoResize: false,
  };
  // @ts-expect-error
  iframes: any[];

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
    this.iframe = this.renderer.createElement('iframe');
    this.renderer.addClass(this.iframe, 'briefing-iframe');
  }

  onIframeLoaded(callback: () => void) {
    const check = () => {
      if (this.iframe?.contentWindow) {
        callback();
      } else {
        setTimeout(check, 100);
      }
    };

    check();
  }

  ngOnInit() {
    const parent = this.elementRef.nativeElement.querySelector('.text-container');
    this.renderer.appendChild(parent, this.iframe);

    this.onIframeLoaded(() => {
      // @ts-expect-error
      this.iframe.contentWindow.document.open();
      // @ts-expect-error
      this.iframe.contentWindow.document.write(this.content);
      // @ts-expect-error
      this.iframe.contentWindow.document.close();
      this.appendStyles();
      this.appendScripts();
      this.iframes = iframeResizerModule.iframeResizer(this.resizerOptions, this.iframe);
    });
  }

  appendStyles() {
    this.styleUrls.forEach((url: string) => {
      const cssLink = this.renderer.createElement('link');
      cssLink.href = url;
      cssLink.rel = 'stylesheet';
      this.renderer.appendChild(this.iframe.contentWindow?.document.head, cssLink);
    });
  }

  appendScripts() {
    this.scriptUrls.forEach((url: string) => {
      const scriptElement = this.renderer.createElement('script');
      scriptElement.src = url;
      scriptElement.text = '';
      this.renderer.appendChild(this.iframe.contentWindow?.document.body, scriptElement);
    });
  }

  ngOnDestroy(): void {
    this.iframes?.forEach(iframe => iframe.iFrameResizer.close());
  }
}
